import {regular} from '@fortawesome/fontawesome-svg-core/import.macro';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';

import './Title.scss';

export interface TitleProps {
  title?: string | React.ReactNode;
  onClose?: () => void;
  small?: boolean;
  medium?: boolean;
  center?: boolean;
}

export const Title: React.FC<TitleProps> = ({ title, onClose, small, medium, center }) => {
  return (
    <div className="content-wrapper-header">
      {onClose && (
        <button className="content-wrapper-header__closing-button" onClick={onClose}>
          <FontAwesomeIcon icon={regular('times')} size="2x" />
        </button>
      )}
      <div className="content-wrapper-header__content">
        <span
          className={classNames('content-wrapper-header__title', {
            'content-wrapper-header__title--small': small,
            'content-wrapper-header__title--medium': medium,
            'content-wrapper-header__title--center': center,
          })}
        >
          {title}
        </span>
      </div>
    </div>
  );
};
